<!-- 
This file refers to GDO-Product-Container 
Do not write any logic here!

    ## Module_Structure ##
    Gdo Desktop:
        -> Gdo Payment:
        -- -> Gdo Payment Container:
        --- -> Gdo Payment Component:
        --- -- -> Gdo Payment XYZ (All other components should be at this level)
-->
<router-outlet></router-outlet>